export interface iEntrada {
  analista: string;
  analista_descripcion: string;
  asunto: string;
  archivos: any[];
  banEntregables: boolean;
  bb: boolean;
  coordinador: string;
  coordinador_descripcion: string;
  copia: string[];
  copia_correo: string;
  copia_descripcion: string;
  delegado: string[];
  delegado_correo: string;
  delegado_descripcion: string;
  descripcion: string;
  descripcion_html: string;
  empresa: string;
  empresa_descripcion: string;
  end: Date;
  estatus: string;
  estatus_descripcion: string;
  fechaControlEstatus?: Date;
  fechaFin?: Date;
  fechaInicio?: Date;
  folio: string;
  idEntrada: string;
  idPadre?: string | null;
  idPadreTema?: string | null;
  lastMod: number;
  leido: boolean;
  leidoFecha: Date;
  leidoHora: Date;
  modo_entrada: string;
  modo_entrada_descripcion: string;
  nameLastUpdate: string;
  prioridad: string;
  prioridad_descripcion: string;
  remitente: string;
  remitente_correo: string;
  remitente_descripcion: string;
  remitente_enviado: string[];
  remitente_enviado_correo: string;
  remitente_enviado_descripcion: string;
  seguimiento: boolean;
  seguimiento_justificacion: string;
  start: Date;
  supervisor: string;
  supervisor_descripcion: string;
  tema: string;
  tema_descripcion: string;
  tipo: string;
  tipoCorreo: number;
  tipo_descripcion: string;
  tsCreation: number;
  tsLastUpdate: number;
  uid: string;
  uidLastUpdate: string;
  vip: boolean;
  edicion?: boolean | null;
  desabilitado?: boolean | null;
  isloading?: boolean;
  id?: string | null;
  relacionados?: any | null;
  idRelacionado?: any | null;
  migrado?: boolean;
}

export const mEntrada: iEntrada = {
  analista: "",
  analista_descripcion: "",
  asunto: "",
  archivos: [],
  banEntregables: false,
  bb: false,
  coordinador: "",
  coordinador_descripcion: "",
  copia: [],
  copia_correo: "",
  copia_descripcion: "",
  delegado: [],
  delegado_correo: "",
  delegado_descripcion: "",
  descripcion: "",
  descripcion_html: "",
  empresa: "",
  empresa_descripcion: "",
  end: new Date(),
  estatus: "",
  estatus_descripcion: "",
  //fechaControlEstatus: new Date(),
  //fechaFin:                      new Date(),
  //fechaInicio:                   new Date(),
  folio: "",
  idEntrada: "",
  //idPadre: "",
  //idPadreTema: "",
  lastMod: 0,
  leido: false,
  leidoFecha: new Date(),
  leidoHora: new Date(),
  modo_entrada: "",
  modo_entrada_descripcion: "",
  nameLastUpdate: "",
  prioridad: "",
  prioridad_descripcion: "",
  remitente: "",
  remitente_correo: "",
  remitente_descripcion: "",
  remitente_enviado: [],
  remitente_enviado_correo: "",
  remitente_enviado_descripcion: "",
  seguimiento: false,
  seguimiento_justificacion: "",
  start: new Date(),
  supervisor: "",
  supervisor_descripcion: "",
  tema: "",
  tema_descripcion: "",
  tipo: "",
  tipoCorreo: 1,
  tipo_descripcion: "",
  tsCreation: 0,
  tsLastUpdate: 0,
  uid: "",
  uidLastUpdate: "",
  vip: false,
  edicion: null,
  desabilitado: null,
  isloading: false,
};

export interface iCatalogos {
  catTema: any[];
  catTipo: any[];
  catTipoTemas?: any[];
  catTipoDespacho?: any[];
  catModoEntrada: any[];
  catPrioridad: any[];
  catEmpresa: any[];
  catRemitente: any[];
  catEnvioAB: any[];
  catFormaEnvio: any[];
  catUsuarios: any[];
  catEntregable: any[];
  catEstatus?: any[];
  catCategorizacion?: any[];
  catCategoria?: any[];
  isloading?: boolean;
}

export interface iComentarios {
  fecha: any;
  descripcion: string;
  bb: any;
  bb_enviado: string;
  bb_enviado_descripcion: string;
  usuario: string;
  tsCreation: string;
  tsLastUpdate: any;
  tema?: string;
  id?: string;
  $id?: string;
}

export interface iFormasEnvio {
  asunto: string;
  empresa: string;
  empresa_descripcion: string;
  entrada: string;
  entrada_tipo: string;
  entrada_tipo_descripcion: string;
  enviado: string;
  enviado_descripcion: string;
  fecha: any;
  leido: boolean;
  leido_fecha: string;
  leido_hora: string;
  reunion_descripcion: string;
  tema: string;
  tipo: string;
  tipo_descripcion: string;
  id?: string;
  $id?: string;
}

export const mCatalogos: iCatalogos = {
  catTema: [],
  catTipo: [],
  catTipoTemas: [],
  catTipoDespacho: [],
  catModoEntrada: [],
  catPrioridad: [],
  catEmpresa: [],
  catRemitente: [],
  catEnvioAB: [],
  catFormaEnvio: [],
  catUsuarios: [],
  catEntregable: [],
  catEstatus: [],
  isloading: false,
};

export const defaultEntada = {
  copia: [],
  copia_correo: "",
  copia_descripcion: "",
  remitente_enviado: [],
  remitente_enviado_correo: "",
  remitente_enviado_descripcion: "",
  tipoCorreo: 1,
  vip: false,
  idEntrada: "",
  isloading: false,
};

export interface iAcuerdo {
  id_acuerdo: string;
  id_forma_envio: string;
  id_tipo_forma: number;
  fechaAcuerdo: Date;
  id_tema: string;
  id_categorizacion: string;
  id_tipo_tema: number | string;
  id_edo_tema: number;
  indice: number;
  nombreTema: string;
  descripcionTema: string;
  descripcionTema_html: string;
  banEsConfidencial: number;
  banEsAprobado: number;
  banEsImpreso: number;
  id_fb_resp_analista: string;
  id_fb_resp_supervisor: string;
  id_fb_resp_coordinador: string;
  id_categoria: number | string;
  numeroEntradasTema: number;
  id_tipo_despacho: number;
  id_empresa: string;
  nombre_empresa: string;
  isloading: boolean;
}

export const mAcuerdo: iAcuerdo = {
  id_acuerdo: "",
  id_forma_envio: "",
  id_tipo_forma: 0,
  fechaAcuerdo: new Date(),
  id_tema: "",
  id_categorizacion: "",
  id_tipo_tema: "",
  id_edo_tema: 0,
  indice: 0,
  nombreTema: "",
  descripcionTema: "",
  descripcionTema_html: "",
  banEsConfidencial: 0,
  banEsAprobado: 0,
  banEsImpreso: 0,
  id_fb_resp_analista: "",
  id_fb_resp_supervisor: "",
  id_fb_resp_coordinador: "",
  id_categoria: '',
  numeroEntradasTema: 0,
  id_tipo_despacho: 0,
  id_empresa: "",
  nombre_empresa: "",
  isloading: false,
};

export interface iEntregables {
  tipo: string;
  tipo_descripcion: string;
  estatus: number;
  estatus_descripcion: string;
  comentarios: string;
  archivos: any[];
  files: any[];
  used: boolean;
  nuevo: boolean;
  edicion: boolean;
  prioridad: number;
  url: null;
  title: null;
  idGas: null;

  ///////////////////////////////////////
  accion?: number | any;
  analista?: string;
  analista_descripcion?: string;
  asunto?: string;
  coordinador?: string;
  coordinador_descripcion?: string;
  creacion?: Date;
  entrada?: string;
  fechaFin?: Date;
  fechaInicio?: Date;
  motivo_cancelacion?: string;
  supervisor?: string;
  supervisor_descripcion?: string;
  tema?: string;
  terminado?: Date;
  timestamp?: number;
  umailUpdate?: string;
  unameUpdate?: string;
  usuario_cancelacion?: string;
  id?: string;
  edicion_usuario?: boolean;
}

export const mEntregables: iEntregables = {
  tipo: "",
  tipo_descripcion: "",
  estatus: 0,
  estatus_descripcion: "",
  comentarios: "",
  archivos: [],
  files: [],
  used: false,
  nuevo: false,
  edicion: false,
  prioridad: 0,
  url: null,
  title: null,
  idGas: null,
  edicion_usuario: false,
};

export const miComentarios = {
  fecha: "",
  descripcion: "",
  bb: "",
  bb_enviado: "",
  bb_enviado_descripcion: "",
  usuario: "",
  tsCreation: "",
  tsLastUpdate: "",
  tema: "",
};

export const miFormasEnvio = {
  asunto: "",
  empresa: "",
  empresa_descripcion: "",
  entrada: "",
  entrada_tipo: "",
  entrada_tipo_descripcion: "",
  enviado: "",
  enviado_descripcion: "",
  fecha: "",
  leido: false,
  leido_fecha: "",
  leido_hora: "",
  reunion_descripcion: "",
  tema: "",
  tipo: "",
  tipo_descripcion: "",
};

export interface iNotificaciones {
  entrada: nEntrada;
  comentarios: nComentarios;
  listaFormaEnvio: nComentarios;
  listaEntregables: nComentarios;
}

export interface nComentarios {
  after: any[];
  before: any[];
}

export interface nEntrada {
  after: any;
  before: any;
  id: string | null;
}

export let mNotificaciones = {
  entrada: { after: [], before: [], id: null },
  comentarios: { after: [], before: [] },
  listaFormaEnvio: { after: [], before: [] },
  listaEntregables: { after: [], before: [] },
};
